import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withCookies } from "react-cookie";
import { withRouter } from "react-router-dom";
import ApiClient from "../../Client";
import { Request } from "../../BackendClient";
import { receive } from "../../action/identity";

const {
  REACT_APP_CDN_HOST: CDN_HOST,
  REACT_APP_AUTH_HOST: AUTH_HOST,
  REACT_APP_IDENTITY_COOKIE: IDENTITY_COOKIE
} = process.env;

const mapStateToProps = ({ identity }) => ({
  identity
});

const mapDispatchToProps = dispatch => ({
  receiveAction: data => dispatch(receive(data))
});

class UserForm extends Component {
  state = {
    name: "",
    email: "",
    phone: "",
    image: "",
    uploadError: "",
    errors: {}
  };

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount = () => {
    const {
      identity: { profile, email, employeeInfo }
    } = this.props;
    const { name, image } = profile || {};
    const { phones } = employeeInfo || {};
    !this.isCancelled &&
      this.setState({
        name: name || "",
        email: email || "",
        phone: (phones || []).join(","),
        image: image || ""
      });
  };

  getAuthKey() {
    const { cookies } = this.props;
    return cookies.get(IDENTITY_COOKIE) || "";
  }

  onChangeInput = (name, value) => {
    this.setState({ [name]: value }, () => {
      this.hasErrors(name) && this.validate(name);
    });
  };

  setError(name, message) {
    this.addErrors({ [name]: message });
  }

  getError(name) {
    return this.state.errors[name] || null;
  }

  addErrors(errors) {
    this.setState({ errors: { ...this.state.errors, ...errors } });
  }

  validate(attributes = null, refresh = true) {
    const errors = refresh ? {} : this.state.errors;
    const { name, email, phone } = this.state;
    if (attributes && !Array.isArray(attributes)) {
      attributes = [attributes];
    }

    if ((!attributes || attributes.includes("name")) && !name) {
      errors["name"] = "Field 'name' is required";
    }

    if (!attributes || attributes.includes("email")) {
      if (email) {
        if (
          !/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i.test(
            email.toLowerCase()
          )
        ) {
          errors["email"] = "Field 'email' is invalid";
        }
      } else {
        errors["email"] = "Field 'email' is required";
      }
    }

    if (!attributes || attributes.includes("phone")) {
      if (phone) {
        const phones = phone.split(",");
        for (let idx = 0; idx < phones.length; idx++) {
          if (!/^(\s*(\+7|7|8)+([0-9]){10}\s*)$/.test(phones[idx])) {
            errors["phone"] =
              phones.length > 1
                ? `Field 'phone' contains invalid value "${phones[idx]}"`
                : "Field 'phone' is invalid";
            break;
          }
        }
      } else {
        errors["phone"] = "Field 'phone' is required";
      }
    }

    !attributes
      ? this.setState({ errors })
      : this.addErrors(
          attributes.reduce(
            (prev, attribute) =>
              Object.assign(prev, { [attribute]: errors[attribute] || null }),
            {}
          )
        );
    return !Object.entries(errors).length;
  }

  hasErrors(name = null) {
    const { errors } = this.state;
    return !!(name ? errors[name] : Object.entries(errors).length);
  }

  findOptionByValue(list, value) {
    if (list && value) {
      for (let idx = 0; idx < list.length; idx++) {
        if (list[idx].value === value) {
          return list[idx];
        }
      }
    }
    return null;
  }

  onImageUploadClick = () => {
    this.refs.fileUploader.click();
  };

  makeCdnRequest = () => new Request({ host: CDN_HOST });

  makePassportRequest = () => new Request({ host: AUTH_HOST });

  submit = () => {
    if (this.validate()) {
      const {
        identity: { profile, employeeInfo, id }
      } = this.props;
      const { name, email, phone, image } = this.state;
      const phones = phone
        .split(",")
        .map(phone => phone.trim())
        .filter(phone => !!phone);
      const data = {
        email,
        profile: {
          [profile && profile.id ? "update" : "create"]: { image, name }
        },
        employeeInfo: {
          [employeeInfo && employeeInfo.id ? "update" : "create"]: {
            phones: { set: phones }
          }
        }
      };
      !this.isCancelled &&
        this.updateUserMutation(id, data).then(id => {
          if (id) {
            this.props.receiveAction({
              email,
              profile: { ...(profile || {}), image, name },
              employeeInfo: { ...(employeeInfo || {}), phones }
            });
            this.passportInvalidateCache().then(
              res => res && this.props.history.goBack()
            );
          }
        });
    }
  };

  updateUserMutation = (id, data) => {
    return ApiClient.setHeader("authKey", this.getAuthKey())
      .request(
        "mutation($id:ID! $data:UserUpdateInput!){updateUser(where:{id:$id} data:$data){id}}",
        { id, data }
      )
      .then(({ updateUser }) => (updateUser && updateUser.id) || null);
  };

  passportInvalidateCache = () => {
    return this.makePassportRequest()
      // .setFormatJson()
      .setEndpoint("/update-identity-cache")
      .setHeader("Authorization", `Bearer ${this.getAuthKey()}`)
      .setMethod("GET")
      .fetchJson();
  };

  fileUploaderHandle = e => {
    e.stopPropagation();
    e.preventDefault();
    const [file] = e.target.files;
    if (file) {
      const form = new FormData();
      form.append("image", file);
      !this.isCancelled &&
        this.makeCdnRequest()
          .setEndpoint("/image/upload")
          .setMethod("POST")
          .setBody(form)
          .fetchJson()
          .then(res => {
            if (res) {
              const { success, images } = res;
              if (success && images && images[0]) {
                const [{ name, url, ext }] = images;
                return (
                  !this.isCancelled &&
                  this.setState({
                    image: `${url}/${name}.${ext}`,
                    uploadError: ""
                  })
                );
              }
            }
            !this.isCancelled &&
              this.setState({ uploadError: "Image upload error." });
          });
    }
  };

  renderError(name) {
    if (this.hasErrors(name)) {
      return <span className="text-danger">{this.getError(name)}</span>;
    }
    return "";
  }

  renderInput(
    name,
    label,
    groupProps = {},
    inputProps = {},
    defaultValue = ""
  ) {
    if (!groupProps.className) {
      groupProps.className = "office-form__group";
    }
    const value = this.state[name] || defaultValue;
    const hasError = this.hasErrors(name) || null;
    if (hasError) {
      groupProps.className += " has-error";
    }
    let component = "input";
    if (inputProps.component) {
      component = inputProps.component;
      delete inputProps.component;
    }
    if (!inputProps.id) {
      inputProps.id = `${name}-input`;
    }
    if (!inputProps.onChange) {
      inputProps.onChange = e => this.onChangeInput(name, e.target.value);
    }
    return (
      <div {...groupProps}>
        <label htmlFor={inputProps.id}>{label}</label>
        {React.createElement(component, { value, ...inputProps })}
        {hasError && <span className="text-danger">{this.getError(name)}</span>}
      </div>
    );
  }

  renderImageField() {
    const { image, uploadError } = this.state;
    const src = image ? `${CDN_HOST}/${image}` : "/images/icon-inst.png";
    return (
      <div className="office-form__avatar">
        <label>
          <input
            type="file"
            ref="fileUploader"
            style={{ display: "none" }}
            onChange={this.fileUploaderHandle}
          />
          <img
            alt="Изображение"
            ref="image"
            className="avatar-uploader"
            src={src}
            onError={() =>
              Object.assign(this.refs.image, {
                src: "/images/icon-inst.png",
                onerror: ""
              })
            }
          />
          <span className="btn btn-link text-white">Загрузить</span>
          {uploadError && (
            <Fragment>
              <br />
              <span className="text-danger">{uploadError}</span>
            </Fragment>
          )}
        </label>
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        <h1 className="office-h1">Данные пользователя</h1>
        <div className="office-form office-form_white">
          {this.renderImageField()}
          {this.renderInput(
            "name",
            "ФИО",
            { className: "office-form__group required" },
            { placeholder: "ФИО" }
          )}
          <div className="office-form__union-2">
            {this.renderInput(
              "email",
              "Электронная почта",
              { className: "office-form__group required" },
              { placeholder: "Электронная почта" }
            )}
            {this.renderInput(
              "phone",
              "Контактный телефон",
              { className: "office-form__group required" },
              { placeholder: "Контактный телефон" }
            )}
          </div>
          <hr />
          <div>
            <button className="btn-gradient" onClick={this.submit}>
              Сохранить
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withCookies(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(UserForm)
  )
);



// WEBPACK FOOTER //
// ./src/containers/user/form.jsx